import { __extends } from "tslib";
import { faMinusCircle, faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import "../../../../style/components/inputNumber.scss";
var InputNumber = (function (_super) {
    __extends(InputNumber, _super);
    function InputNumber() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (event) {
            var value = event.target.value;
            _this.setValue(value);
        };
        _this.decreaseValue = function () {
            var _a = _this.props, minValue = _a.minValue, onChange = _a.onChange;
            var value = Number(_this.props.value) - 1;
            if (value < minValue) {
                return;
            }
            onChange(value);
        };
        _this.increaseValue = function () {
            var _a = _this.props, maxValue = _a.maxValue, onChange = _a.onChange;
            var value = Number(_this.props.value) + 1;
            if (value > maxValue) {
                return;
            }
            onChange(value);
        };
        return _this;
    }
    InputNumber.prototype.render = function () {
        var _a = this.props, value = _a.value, minValue = _a.minValue, maxValue = _a.maxValue;
        return (React.createElement("div", { className: "rb-number-input" },
            React.createElement("div", { className: "rb-btn-crimson rb-btn-number rb-btn-decrease", onClick: this.decreaseValue },
                React.createElement("i", null,
                    React.createElement(FontAwesomeIcon, { icon: faMinusCircle }))),
            React.createElement("input", { className: "rb-input", type: "number", value: value, min: minValue, max: maxValue, onChange: this.onChange, style: { width: "100%" } }),
            React.createElement("div", { className: "rb-btn-crimson rb-btn-number rb-btn-increase", onClick: this.increaseValue },
                React.createElement("i", null,
                    React.createElement(FontAwesomeIcon, { icon: faPlusCircle })))));
    };
    InputNumber.prototype.setValue = function (value) {
        var _a = this.props, minValue = _a.minValue, maxValue = _a.maxValue, onChange = _a.onChange;
        var valueToNumber = Number(value);
        var validatedValue;
        if (valueToNumber < minValue) {
            validatedValue = minValue;
        }
        else if (valueToNumber > maxValue) {
            validatedValue = maxValue;
        }
        else {
            validatedValue = valueToNumber;
        }
        onChange(validatedValue);
    };
    return InputNumber;
}(React.PureComponent));
export { InputNumber };
